<template>
  <router-view></router-view>
</template>
<script>
export default {

};
</script>



// WEBPACK FOOTER //
// src/views/Empty.vue